import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn.js";
export function EmptyState({ icon, title, children, className, }) {
    return (_jsxs("div", { className: cn("flex flex-col items-center gap-2 px-4 py-10 text-center", className), children: [icon && _jsx("div", { className: "text-muted", children: icon }), _jsx("p", { className: "font-medium text-fg", children: title }), children && _jsx("div", { className: "max-w-sm text-sm text-muted", children: children })] }));
}
export function Skeleton({ className }) {
    return _jsx("div", { className: cn("animate-pulse rounded-field bg-soft", className), "aria-hidden": true });
}
//# sourceMappingURL=EmptyState.js.map